import { TutorialVideoStep } from './tutorial-video-widget.component';

export const ADMIN_TUTORIAL_FLOW: TutorialVideoStep[] = [
  {
    screenId: 'admin-dashboard-screen',
    title: 'Admin Dashboard walkthrough',
    recommendedScreenIds: ['dashboard-detailed-screen', 'copy-collection']
  },
  {
    screenId: 'dashboard-detailed-screen',
    title: 'Project Detail walkthrough'
  },
  {
    screenId: 'create-collection',
    title: 'Create Collection walkthrough'
  },
  {
    screenId: 'copy-collection',
    title: 'Copy Collection walkthrough'
  },
  {
    screenId: 'manage-project',
    title: 'Manage Projects walkthrough'
  },
  {
    screenId: 'manage-collections',
    title: 'Manage Collections walkthrough'
  },
  {
    screenId: 'manage-documents',
    title: 'Manage Documents walkthrough'
  },
  {
    screenId: 'manage-custom-department',
    title: 'Manage Custom Department walkthrough'
  }
];

export const USER_DASHBOARD_TUTORIAL_FLOW: TutorialVideoStep[] = [
  {
    screenId: 'user-dashboard',
    title: 'User Dashboard walkthrough'
  },
  {
    screenId: 'manage-project-user-dashboard',
    title: 'Manage Project walkthrough'
  }
];

export const USER_WORKFLOW_TUTORIAL_FLOW: TutorialVideoStep[] = [
  {
    screenId: 'user-dashboard',
    title: 'User Dashboard walkthrough'
  },
  {
    screenId: 'user-detailed-screen',
    title: 'User Project Detail walkthrough'
  },
  {
    screenId: 'manage-project-user-dashboard',
    title: 'Manage Project walkthrough'
  },
  {
    screenId: 'manage-approvals',
    title: 'Manage Approval walkthrough'
  }
];
